import React from 'react';
import { Accordion } from 'react-bootstrap';

const FrequentlyQuestion = ({ question, answer }) => (
    <div>
        <Accordion>
            <Accordion.Item eventKey="0">
                <Accordion.Header>{question}</Accordion.Header>
                <Accordion.Body>
                    {answer}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </div>
);

export default FrequentlyQuestion;
